import { render } from "./ChangesDetails.vue?vue&type=template&id=101a2b47"
import script from "./ChangesDetails.vue?vue&type=script&lang=js"
export * from "./ChangesDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__